"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterRestrictionsByOddId = exports.getBetslipRestrictionId = exports.checkIsMaxBetError = exports.normalizeRestriction = exports.maxBetRestrictionCondition = exports.checkIsCanGetRestrictions = exports.getRestrictionsSelection = exports.getExpressRestrictionsArgs = void 0;
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var betslip_1 = __importDefault(require("@gin-betting/betslip"));
var getBetSystemSizes = betslip_1.default.utils.getBetSystemSizes;
var _a = core_1.default.utils, getIdsFromBetslipOddId = _a.getIdsFromBetslipOddId, getBettingOptions = _a.getBettingOptions, getIdsFromBetslipOddPath = _a.getIdsFromBetslipOddPath, getIdsFromOddId = _a.getIdsFromOddId, joinIdPath = _a.joinIdPath;
var getExpressRestrictionsArgs = function (_a) {
    var id = _a.id, betType = _a.betType, odds = _a.odds, betslipOddIds = _a.betslipOddIds, systemSize = _a.systemSize;
    var selections = [];
    betslipOddIds.forEach(function (betslipOddId) {
        var selection = getRestrictionsSelection(betslipOddId, odds);
        if (selection) {
            selections.push(selection);
        }
    });
    return {
        variables: {
            selections: selections,
            betType: betType,
            systemSizes: getBetSystemSizes({
                betType: betType,
                selectionsCount: selections.length,
                systemSize: systemSize,
            }),
        },
        args: {
            betslipBetId: id,
            betType: betType,
            betslipOddIds: betslipOddIds.toArray(),
        },
    };
};
exports.getExpressRestrictionsArgs = getExpressRestrictionsArgs;
function getRestrictionsSelection(betslipOddId, odds) {
    var oddIdPath = getIdsFromBetslipOddId(betslipOddId).oddId;
    var _a = getIdsFromBetslipOddPath(betslipOddId), matchId = _a.matchId, marketId = _a.marketId, oddId = _a.oddId;
    var odd = odds.get(oddIdPath);
    if (!odd)
        return null;
    return {
        matchId: matchId,
        marketId: marketId,
        oddId: oddId,
        ratio: String(odd.value),
        providerId: matchId.split(':')[0],
    };
}
exports.getRestrictionsSelection = getRestrictionsSelection;
function checkIsCanGetRestrictions(status) {
    var isAuthorized = getBettingOptions().isAuthorized;
    return isAuthorized && core_1.App.BetslipStatus.INITIAL === status;
}
exports.checkIsCanGetRestrictions = checkIsCanGetRestrictions;
var maxBetRestrictionCondition = function (restriction) {
    return restriction.type === core_1.API.RestrictionType.max_bet;
};
exports.maxBetRestrictionCondition = maxBetRestrictionCondition;
var normalizeRestriction = function (restrictions) {
    var maxBetRestriction;
    var simpleRestrictions = restrictions.filter(function (restriction) {
        if (exports.maxBetRestrictionCondition(restriction)) {
            maxBetRestriction = restriction;
            return false;
        }
        return true;
    });
    return { simpleRestrictions: simpleRestrictions, maxBetRestriction: maxBetRestriction };
};
exports.normalizeRestriction = normalizeRestriction;
var checkIsMaxBetError = function (betslipRestriction, stake) {
    var maxBetRestriction = betslipRestriction.find(exports.maxBetRestrictionCondition);
    if (!maxBetRestriction)
        return false;
    var maxBet = maxBetRestriction.maxBet;
    return +stake > maxBet;
};
exports.checkIsMaxBetError = checkIsMaxBetError;
var getBetslipRestrictionId = function (betslipOddIds) {
    if (immutable_1.isCollection(betslipOddIds))
        return betslipOddIds.toSet();
    var ids = lodash_1.isString(betslipOddIds) ? [betslipOddIds] : betslipOddIds;
    return immutable_1.Set(ids);
};
exports.getBetslipRestrictionId = getBetslipRestrictionId;
var filterRestrictionsByOddId = function (restrictions, currOddId) {
    return restrictions.filter(function (restriction) {
        var sportEventId = restriction.sportEventId, marketId = restriction.marketId, oddId = restriction.oddId;
        var ids = getIdsFromOddId(currOddId);
        if (!ids)
            return false;
        if (!sportEventId)
            return true;
        var restrictionMarketId = joinExistedIdPath(sportEventId, marketId);
        var restrictionOddId = joinExistedIdPath(restrictionMarketId, oddId);
        if (restrictionOddId)
            return restrictionOddId === ids.oddId;
        if (restrictionMarketId) {
            return restrictionMarketId === ids.marketId;
        }
        return sportEventId === ids.matchId;
    });
};
exports.filterRestrictionsByOddId = filterRestrictionsByOddId;
function checkIsIdsExisted(ids) {
    return ids.every(function (id) { return typeof id === 'string'; });
}
function joinExistedIdPath() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!checkIsIdsExisted(args))
        return null;
    return joinIdPath.apply(void 0, args);
}
//# sourceMappingURL=utils.js.map